import { Component, Input, OnInit } from '@angular/core';
import { PAYMENT_STATUS } from 'src/app/enums/payment-status.enum';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-order-card-info-ticket',
  templateUrl: './order-card-info-ticket.component.html',
  styleUrls: ['./order-card-info-ticket.component.css']
})
export class OrderCardInfoTicketComponent implements OnInit {

  @Input() tickets: any[] = [];
  @Input() totalPrice: number;

  constructor(
    private utilityService: UtilityService
  ) { }

  ngOnInit(): void {
  }

  getMonth(date: any) {
    return this.utilityService.setDate_DD_MMM_YYYY(date);
  }
}
